export interface IDocumentos {
  id?: number;
  nome?: string;
  xml?: boolean;
  txt?: boolean;
  pdf?: boolean;
  doc?: boolean;
  xls?: boolean;
  ofx?: boolean;
  csv?: boolean;
  json?: boolean;
  xlsx?: boolean;
}

export const DefaultDocumentos: IDocumentos = {
  xml: false,
  txt: false,
  pdf: false,
  doc: false,
  xls: false,
  ofx: false,
  csv: false,
  json: false,
  xlsx: false
}